import { c as _c } from "react/compiler-runtime";
import { useSearchField } from "@website/ui/search-field/search-field.hook";
import styles from "@website/ui/search-field/search-field.module.scss";
import { SearchFieldPropertiesType } from "@website/ui/search-field/search-field.types";
import { FC } from "react";
export const SearchField: FC<SearchFieldPropertiesType> = properties => {
  const $ = _c(16);
  const {
    className,
    disabled,
    fullWidth,
    size: t0,
    variant: t1,
    color: t2,
    StartIcon,
    EndIcon
  } = properties;
  const size = t0 === undefined ? "default" : t0;
  const variant = t1 === undefined ? "normal" : t1;
  const color = t2 === undefined ? "white" : t2;
  const {
    rootProps,
    inputProps,
    startIconProperties,
    endIconProperties
  } = useSearchField(properties);
  const t3 = `${styles["search-field"]} ${disabled ? styles.disabled : ""} ${styles[size]} ${styles[variant]} ${styles[color]} ${fullWidth ? styles["full-width"] : ""} ${className ?? ""}`;
  let t4;
  if ($[0] !== StartIcon || $[1] !== startIconProperties) {
    t4 = StartIcon ? <div {...startIconProperties} className={styles["start-icon"]}>{StartIcon}</div> : null;
    $[0] = StartIcon;
    $[1] = startIconProperties;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== inputProps) {
    t5 = <input {...inputProps} className={styles.input} />;
    $[3] = inputProps;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== EndIcon || $[6] !== endIconProperties) {
    t6 = EndIcon ? <div {...endIconProperties} className={styles["end-icon"]}>{EndIcon}</div> : null;
    $[5] = EndIcon;
    $[6] = endIconProperties;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div className={styles["input-wrapper"]}>{t4}{t5}{t6}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== rootProps || $[13] !== t3 || $[14] !== t7) {
    t8 = <div {...rootProps} className={t3}>{t7}</div>;
    $[12] = rootProps;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};